import { createFileRoute, redirect } from '@tanstack/react-router';

/** A person's page opens on Information. */
export const Route = createFileRoute('/_app/business/people/$userId/')({
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/business/people/$userId/information', params, replace: true });
  },
});
